// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 1000px){
    .PageContainer {
        transform: translateX(15px);
        margin: 25px;
        margin-top: 10px;
    }
}

@media screen and (min-width: 1000px){
    .PageContainer {
        margin: 30px;
    }
}

.PageContainer {
    background-color: #454953;
    height: fit-content;
    min-height: 100vh;
    padding: max(5%, 25px);
    width: max(100vmin, 50%);
    min-width: 50%;
    border: 1px solid #646872;
    color: white;
    border-radius: 30px;
    box-shadow: 
    	5px 5px 5px #00000055,
    	inset 0px 0px 1em #cc66ccff;
}

.PageContainer h1 {
    font-family: monospace;
    text-decoration: underline;
    font-size: calc(15px + 2vw);
    margin-top: 0;
}

.PageContainer p {
    text-align: justify;
    font-size: calc(10px + 0.6vi);
}

.PageContainer a {
    color: #cc66cc;
}
`, "",{"version":3,"sources":["webpack://./src/components/PageContainer.css"],"names":[],"mappings":"AAAA;IACI;QACI,2BAA2B;QAC3B,YAAY;QACZ,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,YAAY;IAChB;AACJ;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;IACtB,wBAAwB;IACxB,cAAc;IACd,yBAAyB;IACzB,YAAY;IACZ,mBAAmB;IACnB;;gCAE4B;AAChC;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;IAC1B,2BAA2B;IAC3B,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB","sourcesContent":["@media screen and (max-width: 1000px){\n    .PageContainer {\n        transform: translateX(15px);\n        margin: 25px;\n        margin-top: 10px;\n    }\n}\n\n@media screen and (min-width: 1000px){\n    .PageContainer {\n        margin: 30px;\n    }\n}\n\n.PageContainer {\n    background-color: #454953;\n    height: fit-content;\n    min-height: 100vh;\n    padding: max(5%, 25px);\n    width: max(100vmin, 50%);\n    min-width: 50%;\n    border: 1px solid #646872;\n    color: white;\n    border-radius: 30px;\n    box-shadow: \n    \t5px 5px 5px #00000055,\n    \tinset 0px 0px 1em #cc66ccff;\n}\n\n.PageContainer h1 {\n    font-family: monospace;\n    text-decoration: underline;\n    font-size: calc(15px + 2vw);\n    margin-top: 0;\n}\n\n.PageContainer p {\n    text-align: justify;\n    font-size: calc(10px + 0.6vi);\n}\n\n.PageContainer a {\n    color: #cc66cc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
